import { SeatSummary, WorkspaceSeatData } from './types'

const seatsInUse = ({ occupied, reserved }: SeatSummary): number =>
  occupied + reserved

export const isAtPlanSeatMax = (
  seats: SeatSummary,
  seatMode: 'dynamic' | 'static',
): boolean =>
  seats.planMax !== null &&
  (seatMode === 'static' ? seats.licensed : seatsInUse(seats)) >= seats.planMax

export const seatsUsed = (workspace: WorkspaceSeatData): number =>
  workspace.seatMode === 'static'
    ? seatsInUse(workspace.seats)
    : workspace.seats.occupied

export const scheduleAfterKeep = (
  atRenewal: number,
  licensed: number,
): number => Math.min(atRenewal + 1, licensed)

export const seatsAtRenewal = (workspace: WorkspaceSeatData): number =>
  workspace.scheduledSeats ?? workspace.seats.licensed

export const seatsLeavingAtRenewal = (workspace: WorkspaceSeatData): number =>
  Math.max(
    0,
    Math.min(
      workspace.seats.available,
      workspace.seats.licensed - seatsAtRenewal(workspace),
    ),
  )
